<template>
  <div class="container-fluid pact-bg min-vh-100 py-5">
    <div class="card custom-card shadow-lg p-4 w-100">
      <h1 class="text-center fw-bold text-white title-gradient p-3 rounded">
        Promise to Address Comprehensive Toxics Act (PACT Act)
      </h1>
      <!-- CSV Upload Modal -->
      <b-modal
        v-model="showUploadModal"
        centered
        hide-footer
        hide-header-close
        title="Upload CSV"
        @hidden="resetUploadModal"
      >
        <div class="modal-body">
          <div class="mb-3">
            <label class="form-label fw-bold">Select Year & Month</label>
            <!-- Native HTML5 month picker -->
            <b-form-input
              type="month"
              v-model="uploadDate"
              class="form-control"
              :max="currentMonth"
            ></b-form-input>
          </div>

          <p v-if="uploadError" class="text-danger fw-bold">{{ uploadError }}</p>
          <p v-if="uploadSuccess" class="text-success fw-bold">{{ uploadSuccess }}</p>
        </div>

        <div class="text-end">
          <b-button
            variant="secondary"
            :disabled="isProcessing"
            @click="showUploadModal = false"
            >Cancel</b-button
          >
          &nbsp;
          <b-button variant="primary" :disabled="isProcessing" @click="confirmUpload">
            <i v-if="isProcessing"></i>
            <i v-else class="fas fa-upload"></i> Upload
          </b-button>
        </div>
         <div v-if="isProcessing" class="loader-overlay">
        <div class="fancy-loader"></div>
      </div>
      </b-modal>
      <div v-if="isProcessing" class="loader-overlay">
        <div class="fancy-loader"></div>
      </div>
      <!-- File Input -->
      <div class="mb-4">
        <label class="form-label fw-bold text-light">Upload CSV File</label>
        <div class="input-group">
          <input
            type="file"
            ref="fileInput"
            accept=".csv"
            class="form-control"
            @change="handleFileChange"
          />
          <button
            class="btn btn-primary"
            :disabled="!selectedFile || isProcessing"
            @click="openUploadModal"
          >
            <i v-if="isProcessing" ></i>
            <i v-else ></i> Upload File
          </button>
        </div>
      </div>

      <!-- Error Modal -->
      <b-modal v-model="showErrorModal" centered hide-footer size="md">
        <template #modal-header>
          <h5 class="modal-title text-danger">Error</h5>
        </template>
        <div class="modal-body text-danger">
          <p class="text-danger">{{ errorMessage }}</p>
        </div>
        <div class="text-end mt-3">
          <b-button variant="primary" @click="showErrorModal = false">Close</b-button>
        </div>
      </b-modal>

      <!-- States Status -->
      <p class="text-light fw-bold">Total Processed States {{ states.length }}</p>

      <!-- Year + Month Filter -->
      <p class="fw-bold text-light">Select Month and Year</p>
      <b-form-input
        type="month"
        v-model="downloadDate"
        :max="currentMonth"
        class="month-year"
      ></b-form-input>
      <!-- States Grid -->
      <div class="cards-container">
        <div
          v-for="state in states"
          :key="state.name"
          class="state-card"
          :class="state.status"
        >
          <div class="state-header">
            <i class="fas fa-map-marker-alt state-map-icon"></i>
            <h5 class="state-name mb-1">
              {{ state.name }} ({{ getStateCode(state.name) }})
             <!--  <i :class="statusIconClass(state.status)" class="ms-2"></i> -->
            </h5>
          </div>
          
          <div class="btn-row">
            <button
              class="btn half-btn download"
              @click.prevent="handleDownload(state.name)"
              :disabled="state.status === 'processing'"
            >
              <i v-if="downloadLoading === state.name" class="fas fa-spinner fa-spin"></i>
              <i v-else class="fas fa-download"></i> Download
            </button>
          </div>
        </div>
      </div>
    </div>
  </div>
</template>

<script>
import Papa from "papaparse";
import { downloadPACTActFile, UploadPACTActCSV } from "../End Points/api";

export default {
  data() {
    return {
      selectedFile: null,
      uploadYear: new Date().getFullYear(),
      uploadMonth: "",
      states: [],
      isProcessing: false,
      downloadLoading: null,
      errorMessage: "",
      uploadError: "",
      uploadSuccess: "",
      showUploadModal: false,
      showErrorModal: false,
      uploadDate: "", // store year+month here like "2025-08"
       currentMonth: this.getPreviousMonth(),
      selectedYear: new Date().getFullYear().toString(),
      selectedMonth: (new Date().getMonth() + 1).toString().padStart(2, "0"),
      downloadDate: "",
      
    };
  },
  created() {
    this.loadStates();
     this.downloadDate = this.getPreviousMonth();
  },
  methods: {
      getPreviousMonth() {
    const now = new Date();
    let year = now.getFullYear();
    let month = now.getMonth(); // Previous month (0-11)
    if (month === 0) { // January -> previous month = December last year
      month = 12;
      year -= 1;
    }
    return `${year}-${String(month).padStart(2, "0")}`;
  },
    getCurrentMonth() {
      const now = new Date();
      const year = now.getFullYear();
      const month = String(now.getMonth() + 1).padStart(2, "0"); // e.g. "08"
      return `${year}-${month}`; // format "YYYY-MM"
    },
    successToast(msg) {
      this.$toast.success(msg, { timeout: 4000 });
    },
    errorToast(msg) {
      this.$toast.error(msg, { timeout: 5000 });
    },
    loadStates() {
      const allStates = [
        "Alabama",
 /*        "Alaska", */
        "Arizona",
        "Arkansas",
        "California",
        "Colorado",
        "Connecticut",
        "Delaware",
        "District of Columbia",
        "Florida",
        "Georgia",
        "Hawaii",
        "Idaho",
       /*  "Illinois", */
        "Indiana",
        "Iowa",
        "Kansas",
        /* "Kentucky", */
        "Louisiana",
        "Maine",
        "Maryland",
        "Massachusetts",
        "Michigan",
        "Minnesota",
        "Mississippi",
        "Missouri",
        "Montana",
        "Nebraska",
        "Nevada",
        "New Hampshire",
        "New Jersey",
        "New Mexico",
        "New York",
        "North Carolina",
     /*    "North Dakota", */
        "Ohio",
        "Oklahoma",
        "Oregon",
        "Pennsylvania",
        "Rhode Island",
        "South Carolina",
        "South Dakota",
        "Tennessee",
        "Texas",
        "Utah",
        "Vermont",
        "Virginia",
        "Washington",
        "West Virginia",
       /*  "Wisconsin", */
        "Wyoming",
      ];
      this.states = allStates.map((s) => ({ name: s, status: "done" }));
    },

    openUploadModal() {
      if (!this.selectedFile) {
        this.uploadError = "Please select a CSV file first.";
        return;
      }
      this.showUploadModal = true;
      this.uploadError = "";
      this.uploadSuccess = "";
      this.uploadYear = this.selectedYear;
      this.uploadMonth = this.selectedMonth || "";
    },

    resetUploadModal() {
      this.uploadError = "";
      this.uploadSuccess = "";
      this.selectedFile = null;
      if (this.$refs.fileInput) this.$refs.fileInput.value = "";
    },

    handleFileChange() {
      const file = this.$refs.fileInput.files[0];
      this.selectedFile = file || null;

      if (file) {
        Papa.parse(file, {
          header: true,
          complete: () => {},
          error: (err) => {
            this.uploadError = "CSV parsing error: " + err.message;
          },
        });
      }
    },

    clearFile() {
      this.selectedFile = null;
      if (this.$refs.fileInput) this.$refs.fileInput.value = "";
    },

    confirmUpload() {
      if (!this.uploadDate) {
        this.uploadError = "Please select a Year & Month.";
        return;
      }

      // Extract Year and Month from selected date
      const [year, month] = this.uploadDate.split("-");

      this.uploadError = "";
      this.isProcessing = true;

      const formData = new FormData();
      formData.append("file", this.selectedFile);
      formData.append("year", year);
      formData.append("month", month);

      UploadPACTActCSV(formData)
        .then(() => {
          this.states.forEach((s) => (s.status = "done"));
          this.uploadSuccess = "CSV uploaded successfully!";
          this.successToast("CSV uploaded successfully!");
          setTimeout(() => {
            this.showUploadModal = false;
          }, 1500);
        })
        .catch((error) => {
          this.uploadError = error.response?.data?.message || "Upload failed. Try again.";
        })
        .finally(() => {
          this.isProcessing = false;
        });
    },
    async handleDownload(stateName) {
      if (this.downloadDate) {
        const [year, month] = this.downloadDate.split("-");
        this.selectedYear = year;
        this.selectedMonth = month;
      } else {
        // Reset to current month if no date selected
        const now = new Date();
        this.selectedYear = now.getFullYear().toString();
        this.selectedMonth = (now.getMonth() + 1).toString().padStart(2, "0");
      }
      this.downloadLoading = stateName;
      const stateCode = this.getStateCode(stateName);
      const monthParam = this.selectedMonth || "";
      const yearParam = this.selectedYear;
      this.isProcessing = true;
      try {
        const response = await downloadPACTActFile(stateCode, monthParam, yearParam);

        // Check if response is empty or invalid
        if (!response || !response.data) throw new Error("Empty response from server");

        // If response is a Blob, check its type
        const contentType = response.headers?.["content-type"] || "";
        if (contentType.includes("application/json")) {
          // Error returned as JSON blob
          const reader = new FileReader();
          reader.onload = () => {
            try {
              const errData = JSON.parse(reader.result);
              this.errorMessage = errData.error || "Download failed.";
              this.showErrorModal = true;
            } catch {
              this.errorMessage = "Download failed.";
              this.showErrorModal = true;
            }
          };
          reader.readAsText(response.data);
        } else {
          let extension = "bin";
          if (contentType.includes("csv")) extension = "csv";
          else if (contentType.includes("pdf")) extension = "pdf";
          else if (contentType.includes("excel")) extension = "xlsx";
          else if (contentType.includes("xml")) extension = "xml";
          else if (contentType.includes("text")) extension = "txt";

          // Normal file download
          const blob = new Blob([response.data], { type: contentType });
          const url = window.URL.createObjectURL(blob);
          const link = document.createElement("a");
          link.href = url;
          link.setAttribute(
            "download",
            `${stateCode}-${yearParam}${monthParam ? "-" + monthParam : ""}.${extension}`
          );
          document.body.appendChild(link);
          link.click();
          link.remove();
          window.URL.revokeObjectURL(url);
        }
      } catch (error) {
        // For network errors or other non-Blob issues
        if (error.response?.data instanceof Blob) {
          const reader = new FileReader();
          reader.onload = () => {
            try {
              const errData = JSON.parse(reader.result);
              this.errorMessage = errData.error || "Download failed.";
              this.showErrorModal = true;
            } catch {
              this.errorMessage = "Download failed.";
              this.showErrorModal = true;
            }
          };
          reader.readAsText(error.response.data);
        } else {
          this.errorMessage =
            error.response?.data?.error || error.message || "Download failed.";
          this.showErrorModal = true;
        }
      } finally {
        this.downloadLoading = null;
          this.isProcessing = false;
      }
    },

    statusIconClass(status) {
      if (status === "done") return "fas fa-check-circle text-success";
      if (status === "processing") return "fas fa-spinner fa-spin text-warning";
      return "";
    },

    getStateCode(stateName) {
      const mapping = {
        Alabama: "AL",
        Alaska: "AK",
        Arizona: "AZ",
        Arkansas: "AR",
        California: "CA",
        Colorado: "CO",
        Connecticut: "CT",
        Delaware: "DE",
        "District of Columbia": "DC",
        Florida: "FL",
        Georgia: "GA",
        Hawaii: "HI",
        Idaho: "ID",
        Illinois: "IL",
        Indiana: "IN",
        Iowa: "IA",
        Kansas: "KS",
        Kentucky: "KY",
        Louisiana: "LA",
        Maine: "ME",
        Maryland: "MD",
        Massachusetts: "MA",
        Michigan: "MI",
        Minnesota: "MN",
        Mississippi: "MS",
        Missouri: "MO",
        Montana: "MT",
        Nebraska: "NE",
        Nevada: "NV",
        "New Hampshire": "NH",
        "New Jersey": "NJ",
        "New Mexico": "NM",
        "New York": "NY",
        "North Carolina": "NC",
        "North Dakota": "ND",
        Ohio: "OH",
        Oklahoma: "OK",
        Oregon: "OR",
        Pennsylvania: "PA",
        "Rhode Island": "RI",
        "South Carolina": "SC",
        "South Dakota": "SD",
        Tennessee: "TN",
        Texas: "TX",
        Utah: "UT",
        Vermont: "VT",
        Virginia: "VA",
        Washington: "WA",
        "West Virginia": "WV",
        Wisconsin: "WI",
        Wyoming: "WY",
      };
      return mapping[stateName] || stateName;
    },
  },
};
</script>

<style scoped>
.pact-bg {
  background: linear-gradient(135deg, #415971, #4b93a5, #b2a5a5);
  overflow-x: hidden;
}
.custom-card {
  background: rgba(255, 255, 255, 0.06);
  border-radius: 20px;
  border: none;
}
.cards-container {
  display: grid;
  grid-template-columns: repeat(auto-fit, minmax(250px, 1fr));
  gap: 1.5rem;
}
.state-card {
  background: rgba(1, 25, 30, 0.1);
  backdrop-filter: blur(12px);
  border-radius: 16px;
  padding: 1.5rem;
  text-align: center;
  color: #fff;
  transition: transform 0.3s ease, box-shadow 0.3s ease;
  will-change: transform;
  transform: translateZ(0);
}
.state-card.done {
  background: linear-gradient(135deg, #2b1111, #1d5267);
}
.state-card.processing {
  background: linear-gradient(135deg, #788e20, #accd09);
}
.state-icon {
  font-size: 2.5rem;
}
.state-name {
  font-weight: bold;
  font-size: 1.1rem;
}
.state-status-label {
  opacity: 0.9;
  font-size: 0.95rem;
}
.btn-row {
  display: flex;
  flex-wrap: wrap;
  justify-content: center;
  gap: 0.5rem;
  margin-top: 1rem;
}
.half-btn {
  flex: 1 1 45%;
  min-width: 100px;
  padding: 0.5rem 0.8rem;
  font-size: 0.9rem;
  white-space: nowrap;
  border-radius: 50px;
  display: inline-flex;
  align-items: center;
  justify-content: center;
  gap: 0.5rem;
  border: none;
  transition: background 0.3s ease;
  text-align: center;
}
.download {
  background: linear-gradient(135deg, #10596f, #3f5670);
  color: #fff;
  font-weight: bold;
}
.download:hover {
  background: linear-gradient(135deg, #0b2849, #005bb5);
}
.preview {
  background: linear-gradient(135deg, #072955, #c41c62);
  color: #fff;
  font-weight: bold;
}
.preview:hover {
  background: linear-gradient(135deg, #110303, #480404);
}
.state-card:hover {
  transform: translateY(-8px);
  box-shadow: 0 12px 40px rgba(0, 114, 255, 0.4);
}
.month-year {
  max-width: 250px;
  padding-left: 40px;
  height: 42px;
  border-radius: 8px;
  border: 2px solid white;
  background: rgba(59, 76, 80, 0.3);
  color: #fff;
  font-weight: 500;
  transition: all 0.3s ease;
  margin-bottom: 1rem;
  color-scheme: dark;
}
.loader-overlay {
  position: fixed;
  top: 0;
  left: 0;
  width: 100vw;
  height: 100vh;
  backdrop-filter: blur(2px);
  display: flex;
  justify-content: center;
  align-items: center;
  z-index: 1000;
}

.fancy-loader {
  width: 60px;
  height: 60px;
  border: 6px solid #e0e0e0;
  border-top: 6px solid #007bff;
  border-radius: 50%;
  animation: slow-spin 1.8s ease-in-out infinite;
  box-shadow: 0 0 10px rgba(0, 123, 255, 0.3);
}
@keyframes slow-spin {
  0% {
    transform: rotate(0deg);
  }
  100% {
    transform: rotate(360deg);
  }
}
</style>
